import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardTitle, Col, Form, Input, Label, Row } from 'reactstrap'
import { PropTypes } from 'prop-types';
import { useHistory } from 'react-router';
import * as warehouseExportTypeApi from '../../apis/warehouseExportTypeApi';
import { Link, withRouter } from 'react-router-dom';
import { getMessage } from './../../Utils/ErrMessageUtils';
import MetaTags from 'react-meta-tags';


function WarehouseExportType(props) {
    const id = props.match.params?.id;
    const [data, setData] = useState({})
    let history = useHistory();
    useEffect(() => {
        if (id) {
            fetchData(id);
        }
    }, [props.match.params])
    const fetchData = (id) => {
        warehouseExportTypeApi.get(id, fetchDataSuccess, fetchDataFail)
    }
    const fetchDataSuccess = (res) => {
        setData(res.data.data)
    }
    const fetchDataFail = (res) => {
        alert(getMessage(res.message))
    }
    const onChangeData = (value, attrName) => {
        data[attrName] = value;
        setData({ ...data })
    }
    const onSubmit = (e) => {
        e.preventDefault();
        if (id) {
            warehouseExportTypeApi.update(id, data, onSubmitSuccess, onSubmitFail)
        }
        else {
            warehouseExportTypeApi.create(data, onSubmitSuccess, onSubmitFail)
        }
    }
    const onSubmitSuccess = (res) => {
        history.push("/warehouse-export-types")
    }
    const onSubmitFail = (res) => {
        alert(getMessage(res.message))
    }
    return (
        <div className="page-content">
            <MetaTags>
                <title>Chi tiết loại phiếu xuất</title>
            </MetaTags>
            <Card>
                <CardBody>
                    <CardTitle className="mb-4">Danh mục loại phiếu xuất</CardTitle>
                    <Form onSubmit={onSubmit}>
                        <div className="mb-3">
                            <Label htmlFor="Shop-name-Input">Tên loại phiếu xuất</Label>
                            <Input
                                type="text"
                                className="form-control"
                                id="warehouse-export-type-name-input"
                                placeholder="Nhập tên loại phiếu xuất"
                                value={data.warehouse_export_type_name}
                                onChange={e => onChangeData(e.target.value, 'warehouse_export_type_name')}
                            />
                        </div>
                        <div>
                            <Row>
                                <Col xs={12} sm="auto">
                                    <button type="submit" className="btn btn-primary w-md">
                                        Lưu
                                    </button>
                                </Col>
                                <Col xs={12} sm="auto">
                                    <Link to="/warehouse-export-types" className="btn btn-secondary w-md">
                                        Hủy
                                    </Link>
                                </Col>
                            </Row>
                        </div>
                    </Form>
                </CardBody>
            </Card>
        </div>
    )
}
WarehouseExportType.propTypes = {
    location: PropTypes.object,
    match: PropTypes.object,
}


export default withRouter(WarehouseExportType);
